<div class="route-component">
    <div class="form-component">

        <tab-control>
            <tab-page title="Debtor By Policy Report" icon="fas fa-file-invoice-dollar">
                <h4>
                    Input Shared Debtor By Policy Report Parameters
                </h4>

                <form #form="ngForm" (ngSubmit)="onRunReport(form)">
                    <!-- Policy Group ID -->
                    <div class="input-group">
                        <auto-complete-dropdown
                            [options]="policyGroups"
                            [label]="'Policy Group'"
                            [placeholder]="'Select a policy group...'"
                            [initialValue]="selectedPolicyGroupId"
                            [required]="true"
                            [invalid]="!selectedPolicyGroupId && formSubmitted"
                            [validationMessage]="'Policy Group is required'"
                            [displayWith]="displayPolicyGroup"
                            (selectionChange)="onPolicyGroupChange($event)">
                        </auto-complete-dropdown>
                    </div>

                    <!-- Period ID -->
                    <div class="input-group">
                        <auto-complete-dropdown
                            [options]="periods"
                            [label]="'Period'"
                            [placeholder]="'Select a period...'"
                            [initialValue]="selectedPeriodId"
                            [required]="true"
                            [invalid]="!selectedPeriodId && formSubmitted"
                            [validationMessage]="'Period is required'"
                            [displayWith]="displayPeriod"
                            (selectionChange)="onPeriodChange($event)">
                        </auto-complete-dropdown>
                    </div>

                    <!-- Action Bar -->
                    <div class="action-bar">
                        <button type="submit" class="button" [disabled]="form.invalid">
                            <i class="fas fa-fire"></i>
                            Run Report
                        </button>
                    </div>
                </form>
            </tab-page>
        </tab-control>

    </div>
</div>